export default {
  isMobile: state => state.width <= 1024 // Allows templates to choose alternative layouts according to viewport size
}
